import { captureSubmitError } from './captureSubmitError'
import { captureSubmitPerformance } from './captureSubmitPerformance'
import { forwardTo } from '../default/forwardTo'
import { updateSession } from '../default/updateSession'
import { verifyPhoneInternal } from '../middleware/verifyPhoneInternal'

/**
 * Submits phone number for sms code verification
 * @param {string} phone
 * @param {string} sessionId
 * @param {string} redirect
 * @returns {Promise<boolean>}
 */
export async function submitPhoneInternal(phone, sessionId, redirect) {
  const startTime = performance.now()
  try {
    // make sure the phone value passed to verifyPhone starts with +1
    const verifyNum = phone.startsWith('+1') ? phone : `+1${phone}`
    const success = await verifyPhoneInternal(verifyNum)
    if (success) {
      const phoneSession = verifyNum.replace('+1', '')
      updateSession(sessionId, 'phone', phoneSession)

      if (window.location.pathname !== redirect) {
        forwardTo(redirect)
      }

      captureSubmitPerformance(performance.now() - startTime)
      return true
    }
  } catch (error) {
    captureSubmitPerformance(performance.now() - startTime)
    captureSubmitError(/** @type {Error} */ (error), false)
  }
  return false
}
